import axios from 'axios'

const state = () => ({
  usefulLink: []
})

const getters = {
  usefulLink(state) {
    return state.usefulLink
  }
}

const mutations = {
  SET_USEFULLINK(state, payload){
    state.usefulLink = payload
  },
  DELETE_USEFULLINK(state, id){
    state.usefulLink = state.usefulLink.filter((x) => x.id != id);
  },
  ADD_USEFULLINK(state, data){
    state.usefulLink.push(data);
  },
  EDIT_USEFULLINK(state, payload){
    state.usefulLink = state.usefulLink.map((vm)=>{
      if(vm.id == payload.id){return payload}
      else{ return vm }
    })
  }
}

const actions = {
  getUsefulLink({commit}){
    axios.get('https://api.geomalaka.uz/api/main/foydali-havolalar/')
    .then((res)=>{
      commit("SET_USEFULLINK", res.data)
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  deleteUsefulLink({commit}, id){
    axios.delete(`https://api.geomalaka.uz/api/main/foydali-havolalar/${id}/`)
    .then((res)=>{
      commit("DELETE_USEFULLINK", id)
      this._vm.$toast('Deleted', {type: 'success'})
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  addUsefulLink({commit}, payload){
    axios.post('https://api.geomalaka.uz/api/main/foydali-havolalar/', payload)
    .then((res)=>{
      commit("ADD_USEFULLINK", res.data)
      this._vm.$toast(res.statusText, {type: 'success'});
    })
    .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  },

  editUsefulLink({commit}, payload){
    axios.put(`https://api.geomalaka.uz/api/main/foydali-havolalar/${payload.id}/`, payload.data)
      .then((res)=>{
        commit("EDIT_USEFULLINK", res.data)
        this._vm.$toast('Successful', {type: 'success'});
      })
      .catch((error)=>{this._vm.$toast(error.message, {type: 'error'});})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

